import React from "react";
import {
  Box,
  Flex,
  Heading,
  ListItem,
  UnorderedList,
  Text,
  IconButton,
} from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";

export const UsersList = ({
  title,
  usersList,
  isTeacher = false,
  isRemoveButton = false,
  removeSubscriber,
}) => {
  return (
    <Box
      style={{
        background: "rgb(255, 255, 255)",
        boxShadow: "rgba(0, 176, 255, 0.2) 0px 10px 10px 0px",
        borderRadius: "20px",
        border: "1px solid rgba(0, 176, 255, 0.4)",
        margin: "20px 0 0",
      }}
    >
      <Heading
        as="h2"
        style={{
          fontSize: "20px",
          color: "rgb(66, 71, 112)",
          fontFamily: "Open Sans",
          fontWeight: "600",
          padding: "20px",
          borderBottom: "1px solid rgb(230, 233, 241)",
        }}
      >
        {title}
      </Heading>
      <UnorderedList style={{ margin: 0 }}>
        {React.Children.toArray(
          usersList.map((user, index) => (
            <ListItem
              style={{
                listStyle: "none",
                padding: "20px",
                ...(usersList.length - 1 === index
                  ? {}
                  : { borderBottom: "1px solid rgb(230, 233, 241)" }),
              }}
            >
              <Flex
                style={{
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={{
                    fontSize: "16px",
                    color: "rgb(66, 71, 112)",
                    fontFamily: "Open Sans",
                  }}
                >{`${user.firstName} ${user.lastName}`}</Text>
                {isTeacher && (
                  <Text
                    style={{
                      fontSize: "19px",
                      color: "rgb(66, 71, 112)",
                      fontFamily: "Open Sans",
                    }}
                  >
                    {user.email}
                  </Text>
                )}
                {isRemoveButton && (
                  <IconButton
                    variant="ghost"
                    aria-label="Remove subscriber"
                    onClick={() => removeSubscriber(user.id)}
                    colorScheme="red"
                    icon={<DeleteIcon />}
                  />
                )}
              </Flex>
            </ListItem>
          ))
        )}
      </UnorderedList>
    </Box>
  );
};
